(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/helper-games/assets/javascripts/get-game-aria-label.js') >= 0) return;  svs.modules.push('/components/marketplace/helper-games/assets/javascripts/get-game-aria-label.js');

'use strict';

const getStatusDesc = svs.components.marketplace.helpers.games.getStatusDesc;
const format = svs.utils.format;
const showFewSharesLeftRibbon = svs.components.marketplace.helpers.games.showFewSharesLeftRibbon;
const _dateFns = dateFns,
  isFuture = _dateFns.isFuture;
const helpers = svs.components.lbUtils.helpers;
const gamesConstants = svs.components.marketplaceData.gamesConstants;
const getProductDisplayName = svs.components.lbUtils.brandMapping.fn.getProductDisplayName;
const buyLastText = buyStop => helpers.formatDate.formatDate(buyStop, true, true);
const resolveStatusLabel = (isRetail, fractionPrice, currentUserNumberOfShares) => {
  if (isRetail) {
    const price = format.Currency(fractionPrice);
    return price ? "".concat(price, " kr") : '-';
  }
  const cost = format.Currency(fractionPrice * currentUserNumberOfShares);
  return parseInt(cost, 10) ? "".concat(cost, " kr") : '';
};
const getFractionsText = (currentUserNumberOfShares, fractionPrice, isRetail, isFinished) => {
  let hadOrHave = 'har';
  let shareOrShares = 'andel';
  let numberOfShares = currentUserNumberOfShares;
  if (isFinished) {
    hadOrHave = 'hade';
  }
  if (currentUserNumberOfShares > 1) {
    shareOrShares = 'andelar';
  }
  if (currentUserNumberOfShares === 1) {
    numberOfShares = 'en';
  }
  const fractionsText = "Du ".concat(hadOrHave, " ").concat(numberOfShares, " ").concat(shareOrShares);
  if (fractionPrice) {
    return "".concat(fractionsText, " f\xF6r totalt ").concat(resolveStatusLabel(isRetail, fractionPrice, currentUserNumberOfShares));
  }
  return fractionsText;
};
const noParticipationText = (buyStop, canBuy, gameStatus, isCurrentUserAuthenticated, isSubmitted) => {
  if (canBuy && !isSubmitted && isFuture(buyStop)) {
    return "K\xF6p senast ".concat(buyLastText(buyStop));
  }
  if (!isCurrentUserAuthenticated) {
    return '';
  }
  const participationText = isSubmitted || gameStatus === gamesConstants.GAME_STATUS_DRAW_CLOSED ? 'deltog' : 'deltar';
  return "Du ".concat(participationText, " inte");
};
const getParticipationText = (game, isCurrentUserAuthenticated, isListing, isRetail) => {
  const buyStop = game.buyStop,
    currentUserNumberOfShares = game.currentUserNumberOfShares,
    fractionPrice = game.fractionPrice,
    gameStatus = game.status,
    isFinished = game.isFinished,
    isSoldOut = game.isSoldOut,
    isSubmitted = game.isSubmitted,
    ownerName = game.ownerName;
  if (isListing && isRetail) {
    if (gameStatus === gamesConstants.GAME_STATUS_DRAW_CLOSED) {
      return null;
    }
    if (currentUserNumberOfShares > 0) {
      return "\xC4gare: ".concat(ownerName, ", ") + "".concat(getFractionsText(currentUserNumberOfShares, fractionPrice, isRetail, isFinished), ", ") + "".concat(resolveStatusLabel(isRetail, fractionPrice, currentUserNumberOfShares), " per andel");
    }
    return "\xC4gare: ".concat(ownerName, ", ") + "".concat(noParticipationText(buyStop, !isSoldOut, gameStatus, isCurrentUserAuthenticated, isSubmitted), ", ") + "".concat(resolveStatusLabel(isRetail, fractionPrice, currentUserNumberOfShares), " per andel");
  }
  if (currentUserNumberOfShares > 0) {
    return getFractionsText(currentUserNumberOfShares, fractionPrice, isRetail, isFinished);
  }
  return noParticipationText(buyStop, !isSoldOut, gameStatus, isCurrentUserAuthenticated, isSubmitted);
};
const getGameAriaLabel = _ref => {
  let game = _ref.game,
    groupId = _ref.groupId,
    isCurrentUserAuthenticated = _ref.isCurrentUserAuthenticated,
    isListing = _ref.isListing,
    isRetail = _ref.isRetail;
  const fractionPrice = game.fractionPrice,
    gameStatus = game.status,
    isAllowedToSubmit = game.isAllowedToSubmit,
    name = game.name,
    preliminaryRowExists = game.preliminaryRowExists,
    productId = game.productId,
    soldShares = game.soldShares;
  const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);
  const showFewSharesLeft = showFewSharesLeftRibbon(game, groupId);
  const sharesLeft = (game === null || game === void 0 ? void 0 : game.maxFractions) - (game === null || game === void 0 ? void 0 : game.soldShares);
  const gameStatusDesc = getStatusDesc(gameStatus, isAllowedToSubmit, preliminaryRowExists);
  const participationText = getParticipationText(game, isCurrentUserAuthenticated, isListing, isRetail);
  return [productId ? getProductDisplayName(productId) : '', name ? "".concat(capitalizeFirstLetter(name)) : '', showFewSharesLeft ? "".concat(sharesLeft, " st. kvar") : '', participationText,
  isAllowedToSubmit ? "Laget har ".concat(format.Currency(fractionPrice * soldShares), " kr att spela f\xF6r") : '', gameStatusDesc].filter(text => (text === null || text === void 0 ? void 0 : text.trim()) !== '').join(', ');
};

setGlobal('svs.components.marketplace.helpers.games.getGameAriaLabel', getGameAriaLabel);

 })(window);